/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiCursorAIcon24Solid = forwardRef('UiCursorAIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8.61 3.065c-1.482-1.114-3.6-.058-3.602 1.796l-.017 14.79c-.003 2.162 2.749 3.083 4.048 1.355l3.542-4.712a.75.75 0 0 1 .6-.3l5.896.007c2.162.003 3.083-2.749 1.354-4.048L8.61 3.065Z" })));
});
